import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

const InsertStation = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlBlockPrefix}getstationcodeinsertby`
      );
      if (response.data.status === "ok") {
        setData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const uniqueDivisions = Array.from(
    new Map(
      data.map((item) => [item.division_id, item.division_name])
    ).entries()
  );

  const [entry, setEntry] = useState({
    division_id: "",
    section: "",
    station: "",
    station_code: "",
  });

  const filteredSections = data.filter(
    (item) => item.division_id === parseInt(entry.division_id)
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "division_id") {
      setEntry((prev) => ({ ...prev, division_id: value, section: "" }));
    } else {
      setEntry((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClear = () => {
    setEntry({
      division_id: "",
      section: "",
      station: "",
      station_code: "",
    });
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `${urlBlockPrefix}insertstationcode
`,

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(entry),
        }
      );
      const result = await response.json();

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      toast.success("Upload successful");
    } catch (error) {
      toast.error("Error submitting data:", error);
    }

    handleClear();
  };
  return (
    <div className="p-4">
      <h5 className="bg-dark text-white text-center py-2">
        Insertion Of Station
      </h5>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-dark text-center">
            <tr>
              <th>Division</th>
              <th>Section</th>
              <th>Station Name</th>
              <th>Station Code</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <select
                  name="division_id"
                  className="form-select text-black fw-bold text-center"
                  value={entry.division_id}
                  onChange={handleChange}
                >
                  <option hidden value="">
                    Select Division
                  </option>
                  {data &&
                    uniqueDivisions.map(([id, name]) => (
                      <option key={id} value={id}>
                        {name}
                      </option>
                    ))}
                </select>
              </td>
              <td>
                <select
                  name="section"
                  className="form-select text-black fw-bold text-center"
                  value={entry.section}
                  onChange={handleChange}
                  disabled={!entry.division_id}
                >
                  <option hidden value="">
                    Select Section
                  </option>
                  {data &&
                    filteredSections.map((item, index) => (
                      <option key={index} value={item.section_name}>
                        {item.section_name}
                      </option>
                    ))}
                </select>
              </td>
              <td>
                <input
                  name="station"
                  type="text"
                  className="form-control text-center"
                  placeholder="Station Name"
                  value={entry.station}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  name="station_code"
                  type="text"
                  className="form-control text-center"
                  placeholder="Station Code"
                  value={entry.station_code}
                  onChange={handleChange}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="text-center mt-3">
        <button className="btn btn-success px-4" onClick={handleSubmit}>
          Upload
        </button>
      </div>
    </div>
  );
};

export default InsertStation;
